import { homeRoomFromStored, type HomeRoomData } from "@/home/storage";

/** Parse defender home snapshot from `startRaid` response. */
export function parseRaidHomeRoom(raw: unknown): HomeRoomData | null {
  if (!raw) return null;
  return homeRoomFromStored(raw);
}
